import {
  COMMENT_BOX,
  DROPDOWN,
  MULTIPLE_CHOICE,
  MULTI_CHOICE_QUESTIONS,
  SINGLE_CHOICE,
  SINGLE_TEXTBOX,
  SLIDER,
  STAR_RATING,
} from '../questionTypes';

export const mapQuestionTypeToAPI = type => {
  switch (type) {
    case SINGLE_CHOICE:
      return { family: 'single_choice', subtype: 'vertical' };
    case DROPDOWN:
      return { family: 'single_choice', subtype: 'menu' };
    case MULTIPLE_CHOICE:
      return { family: 'multiple_choice', subtype: 'vertical' };
    case SINGLE_TEXTBOX:
      return { family: 'open_ended', subtype: 'single' };
    case COMMENT_BOX:
      return { family: 'open_ended', subtype: 'essay' };
    case STAR_RATING:
      return { family: 'matrix', subtype: 'rating' };
    case SLIDER:
      return { family: 'open_ended', subtype: 'single' };
    default:
      return { family: 'single_choice', subtype: 'vertical' };
  }
};

export const mapAnswersToAPI = (question = {}, isQuiz = false) => {
  let mappedAnwers = null;
  if (MULTI_CHOICE_QUESTIONS.includes(question.questionType)) {
    const choices = [];
    let position = 1;
    question.answers.forEach(answer => {
      if (answer.answer) {
        const choice = {
          text: answer.answer,
          visible: true,
          position,
        };
        if (isQuiz) {
          choice.quiz_options = {
            score: answer.score ? parseInt(answer.score, 10) : 0,
          };
        }
        choices.push(choice);
        position += 1;
      }
    });
    mappedAnwers = {
      choices,
    };
  } else if (question.questionType === STAR_RATING) {
    mappedAnwers = {
      rows: [
        {
          visible: true,
          text: '',
          position: 1,
        },
      ],
      choices: [
        {
          weight: 1,
          text: '',
        },
        {
          weight: 2,
          text: '',
        },
        {
          weight: 3,
          text: '',
        },
        {
          weight: 4,
          text: '',
        },
        {
          weight: 5,
          text: '',
        },
      ],
    };
  }
  return mappedAnwers;
};

export const handleRequired = (question, apiQuestion) => {
  const updatedQuestion = { ...apiQuestion };

  if (question.required) {
    updatedQuestion.required = {
      text: 'Response is required',
      type: question.questionType === MULTIPLE_CHOICE ? 'at_least' : 'all',
      amount: '1',
    };
  } else {
    delete updatedQuestion.required;
  }

  return updatedQuestion;
};

export const handleStarQuestionType = (question, apiQuestion) => {
  const updatedQuestion = { ...apiQuestion };
  if (question.questionType === STAR_RATING) {
    updatedQuestion.display_options = {
      display_type: 'emoji',
      display_subtype: 'star',
    };
    updatedQuestion.forced_ranking = false;
  }

  return updatedQuestion;
};

export const handleSliderQuestionType = (question, apiQuestion) => {
  const updatedQuestion = { ...apiQuestion };
  if (question.questionType === SLIDER) {
    updatedQuestion.display_options = {
      right_label: `${question.max}` || '100',
      display_type: 'slider',
      custom_options: {
        starting_position: 0,
        step_size: 1,
      },
      left_label: `${question.min}` || '0',
    };

    updatedQuestion.validation = {
      sum_text: '',
      min: question.min ? parseInt(question.min, 10) : 0,
      text: 'Please enter a whole number between {0} and {1}.',
      max: question.max ? parseInt(question.max, 10) : 100,
      type: 'integer',
    };
  }
  return updatedQuestion;
};

export const mapQuestionToAPI = (question, position, isQuiz, originalQuestionFromApi) => {
  const familySubType = mapQuestionTypeToAPI(question.questionType);

  let apiQuestion = {
    family: familySubType.family,
    subtype: familySubType.subtype,
    ...(originalQuestionFromApi || {}),
    ...{
      headings: [
        {
          heading: question.question,
        },
      ],
      position,
    },
  };

  delete apiQuestion.href;
  delete apiQuestion.layout;

  if (!question.isNew) {
    apiQuestion.id = question.id;
  }

  apiQuestion = handleRequired(question, apiQuestion);

  if (MULTI_CHOICE_QUESTIONS.includes(question.questionType) || question.questionType === STAR_RATING) {
    apiQuestion.answers = mapAnswersToAPI(question, isQuiz);
  }

  apiQuestion = handleStarQuestionType(question, apiQuestion);

  apiQuestion = handleSliderQuestionType(question, apiQuestion);

  if (isQuiz && MULTI_CHOICE_QUESTIONS.includes(question.questionType)) {
    apiQuestion.quiz_options = {
      scoring_enabled: true,
      feedback: {
        correct_text: "Nice! That's correct",
        incorrect_text: "Nope, that's wrong",
      },
    };
  }

  return apiQuestion;
};

export const buildQuestionData = (questions, surveyType) => {
  const questionsToSend = [];
  questions.forEach((question, position) => {
    const mappedQuestion = mapQuestionToAPI(question, position + 1, surveyType === 'quiz');

    questionsToSend.push(mappedQuestion);
  });
  return { questionsToSend };
};
